import styled, { css } from 'styled-components';

import { rem } from '../../utils';
import { Text } from '../Text';

export interface AlertContainerProps {
  type: 'success' | 'error' | 'warning' | 'info';
}

export const StyledText = styled.span`
  flex: auto;
`;

export const StyledWrapper = styled.div<AlertContainerProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${({ theme }) => css`
    gap: ${rem(theme.Spacing.Size.XSmall)};
    padding: ${rem(theme.Spacing.Size.XSmall)};
    border-radius: ${rem(theme.Border.Radius.Medium)};
    color: ${theme.Color.Neutrals.Dark};
  `}

  ${({ theme, type }) => {
    switch (type) {
      case 'success':
        return `
        background-color: ${theme.Color.Feedback.SuccessLight};
        fill: ${theme.Color.Feedback.Success};
      `;
      case 'error':
        return `
        background-color: ${theme.Color.Feedback.AlertLight};
        fill: ${theme.Color.Feedback.Alert};
      `;
      case 'warning':
        return `
        background-color: ${theme.Color.Feedback.WarningLight};
        fill: ${theme.Color.Feedback.Warning};
      `;
      case 'info':
        return css`
          position: relative;
          background-color: ${theme.Color.Feedback.InfoLight};
          fill: ${theme.Color.Feedback.Info};
          z-index: 2;
          border: ${rem(theme.Border.Size.Small)} solid ${theme.Components.Alert.Info.Border.Color};
        `;
    }
  }}
`;
